/**
 * DB-295 — the parts of an id that an id cell can never break inside.
 *
 * The cell sets ids with `white-space: normal; word-break: normal; overflow-wrap: normal`
 * (AuthoritiesList BETWEEN_WORDS), so the browser breaks only where CSS line breaking allows
 * it: at a space, and after a hyphen — except before a digit (UAX #14 LB25: HY × NU), which is
 * why "y4roup-01" stays one piece. A control number ("Oaun2026056278") has no such place and is
 * one part. The id column has to hold the widest PART on one line, not the widest whole id:
 * sized for "czna386cp4-y4roup-01" whole (144 px), it took 39 px from the heading and the type
 * names no longer fitted at 1920 (gate-55167df3a).
 */
// No lookbehind: the bundle is not transpiled for it and no other production code relies on it.
export var idUnbreakableParts = function (id) { return id
    .replace(/-(?=[^\d\s-])/g, '-\n')
    .split(/\s+/)
    .filter(function (part) { return part.length > 0; }); };
export default idUnbreakableParts;
